import React from "react";
import type { TaskCardProps } from "../types";
import { ChevronRightIcon, FileTextIcon } from "./icons";

const TaskCard = ({
  tone = "info",
  icon: Icon = FileTextIcon,
  eyebrow,
  title,
  subtitle,
  details = [],
  description,
  actionLabel,
  onClick,
}: TaskCardProps) => {
  const clickable = typeof onClick === "function";
  const Component = (clickable ? "button" : "article") as any;

  return (
    <Component
      type={clickable ? "button" : undefined}
      onClick={onClick}
      className={`pp-actions-task-card is-${tone}${clickable ? " is-clickable" : ""}`}
    >
      <div className="pp-actions-task-icon-panel" aria-hidden="true">
        <span className="pp-actions-task-icon">
          <Icon />
        </span>
      </div>

      <div className="pp-actions-task-body">
        {clickable && (
          <ChevronRightIcon
            className="pp-actions-card-chevron"
            aria-hidden="true"
          />
        )}

        {eyebrow && (
          <span className="pp-actions-eyebrow">
            <span className="pp-actions-eyebrow-dot" />
            {eyebrow}
          </span>
        )}

        <h3>{title}</h3>

        {subtitle && <p className="pp-actions-task-subtitle">{subtitle}</p>}

        {details.filter(Boolean).length > 0 && (
          <div className="pp-actions-task-details">
            {details.filter(Boolean).map((detail, index) => (
              <span key={index}>{detail}</span>
            ))}
          </div>
        )}

        <div className="pp-actions-task-bottom">
          {description && (
            <p className="pp-actions-task-description">{description}</p>
          )}

          {actionLabel && (
            <span className="pp-actions-task-button">
              {actionLabel}
              <ChevronRightIcon aria-hidden="true" />
            </span>
          )}
        </div>
      </div>
    </Component>
  );
};



export default TaskCard;
